// Mailing List Actions
export const FETCH_MAILING_LIST_REQUEST = 'FETCH_MAILING_LIST_REQUEST';
export const FETCH_MAILING_LIST_SUCCESS = 'FETCH_MAILING_LIST_SUCCESS';
export const FETCH_MAILING_LIST_FAILURE = 'FETCH_MAILING_LIST_FAILURE';

export const CREATE_MAILING_LIST_REQUEST = 'CREATE_MAILING_LIST_REQUEST';
export const CREATE_MAILING_LIST_SUCCESS = 'CREATE_MAILING_LIST_SUCCESS';
export const CREATE_MAILING_LIST_FAILURE = 'CREATE_MAILING_LIST_FAILURE';

export const fetchMailingListRequest = (options = {}) => ({
    type: FETCH_MAILING_LIST_REQUEST,
    payload: options,
});

export const fetchMailingListSuccess = (data) => ({
    type: FETCH_MAILING_LIST_SUCCESS,
    payload: data,
});

export const fetchMailingListFailure = (error) => ({
    type: FETCH_MAILING_LIST_FAILURE,
    payload: error,
});

export const createMailingListRequest = (mailingListData) => ({
    type: CREATE_MAILING_LIST_REQUEST,
    payload: mailingListData,
});

export const createMailingListSuccess = (data) => ({
    type: CREATE_MAILING_LIST_SUCCESS,
    payload: data,
});

export const createMailingListFailure = (error) => ({
    type: CREATE_MAILING_LIST_FAILURE,
    payload: error,
});

export const UPDATE_MAILING_LIST_REQUEST = 'UPDATE_MAILING_LIST_REQUEST';
export const UPDATE_MAILING_LIST_SUCCESS = 'UPDATE_MAILING_LIST_SUCCESS';
export const UPDATE_MAILING_LIST_FAILURE = 'UPDATE_MAILING_LIST_FAILURE';

export const DELETE_MAILING_LIST_REQUEST = 'DELETE_MAILING_LIST_REQUEST';
export const DELETE_MAILING_LIST_SUCCESS = 'DELETE_MAILING_LIST_SUCCESS';
export const DELETE_MAILING_LIST_FAILURE = 'DELETE_MAILING_LIST_FAILURE';

export const CLEAR_MAILING_LIST_ERROR = 'CLEAR_MAILING_LIST_ERROR';

export const updateMailingListRequest = (emailId, mailingListData) => ({
    type: UPDATE_MAILING_LIST_REQUEST,
    payload: { emailId, mailingListData },
});

export const updateMailingListSuccess = (data) => ({
    type: UPDATE_MAILING_LIST_SUCCESS,
    payload: data,
});

export const updateMailingListFailure = (error) => ({
    type: UPDATE_MAILING_LIST_FAILURE,
    payload: error,
});

export const deleteMailingListRequest = (emailId) => ({
    type: DELETE_MAILING_LIST_REQUEST,
    payload: emailId,
});

export const deleteMailingListSuccess = (emailId) => ({
    type: DELETE_MAILING_LIST_SUCCESS,
    payload: emailId,
});

export const deleteMailingListFailure = (error) => ({
    type: DELETE_MAILING_LIST_FAILURE,
    payload: error,
});

export const clearMailingListError = () => ({
    type: CLEAR_MAILING_LIST_ERROR,
});
